export const AppVersionTone = {
  Default: 'default',
  OnBrand: 'onBrand',
  OnBrandMuted: 'onBrandMuted',
} as const;

export type AppVersionToneType =
  (typeof AppVersionTone)[keyof typeof AppVersionTone];

export type AppVersionProps = {
  version?: string;
  collapsed?: boolean;
  tone?: AppVersionToneType;
  testId?: string;
};
